export var calculateImagePositionWithMouseCoord = function (viewOffsets, mouseCoords, zoomIntensity) {
    var width = viewOffsets.width, height = viewOffsets.height;
    var xMouse = mouseCoords.xMouse, yMouse = mouseCoords.yMouse;
    // calculate size of each side due to transform
    // scale * (1 => for classic image size / (0.5 => for half size on each size * (scale => scale reference - 1 => transform start at 2)))
    var ratioWithTransform = zoomIntensity * (1 / (0.5 * (zoomIntensity - 1)));
    var xDifferenceOnScale = width / ratioWithTransform;
    var yDifferenceOnScale = height / ratioWithTransform;
    // Distance pouvant etre parcouru par la souris entre le debut et la fin de l'image apres le scale
    var xIntervalAfterScale = width - 2 * xDifferenceOnScale;
    var yIntervalAfterScale = height - 2 * yDifferenceOnScale;
    // get position of cursor related to scale
    var offsetXPercent = Math.abs((xMouse - xDifferenceOnScale) / xIntervalAfterScale);
    var offsetYPercent = Math.abs((yMouse - yDifferenceOnScale) / yIntervalAfterScale);
    // position max de la souris en fin d'icons
    var xMaxInterval = 2 * xDifferenceOnScale;
    var yMaxInterval = 2 * yDifferenceOnScale;
    return "".concat(xDifferenceOnScale - offsetXPercent * xMaxInterval, "px ").concat(yDifferenceOnScale - offsetYPercent * yMaxInterval, "px");
};
